import styled from "styled-components";
import { colors } from "../../../styles/colors";

export const StyledNavContainer = styled.div`
  position: fixed;
  bottom: 32px;
  left: 50%;
  transform: translateX(-50%);
  width: 280px;
  height: 50px;
  border-radius: 100px;
  background: ${colors.white};
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
  z-index: 10;
  box-sizing: border-box;

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    border-radius: 100px;
    padding: 1px;
    background: linear-gradient(
      90deg,
      ${colors.gradientTeal},
      ${colors.gradientBlue}
    );
    -webkit-mask:
      linear-gradient(#fff, #fff) content-box,
      linear-gradient(#fff, #fff);
    mask:
      linear-gradient(#fff, #fff) content-box,
      linear-gradient(#fff, #fff);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
    pointer-events: none;
  }
`;

export const StyledNav = styled.nav`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  gap: 24px;
  border-radius: 100px;
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 0.98) 0%,
    rgba(0, 234, 178, 0.03) 50%,
    rgba(0, 78, 247, 0.03) 100%
  );
  box-sizing: border-box;
  animation-timing-function: ease-out;
  animation-duration: 300ms;
`;

export const NavItem = styled.button<{
  $isActive: boolean;
  $iconType?: string;
}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: visible;
  outline: none;
  -webkit-tap-highlight-color: transparent;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  &:hover {
    transform: translateY(-1px);
  }

  &:focus {
    outline: none;
    background: transparent;
  }

  &:active {
    transform: translateY(0);
    transition: all 0.1s ease;
    background: transparent;
    outline: none;
  }

  img {
    width: ${({ $isActive, $iconType }) => {
      if ($iconType === "setting") {
        return $isActive ? "30.41px" : "20.91px";
      }
      if ($iconType === "contact") {
        return $isActive ? "29.09px" : "20px";
      }
      if ($iconType === "dashboard") {
        return $isActive ? "34.4px" : "24px";
      }
      return $isActive ? "28px" : "22px";
    }};
    height: ${({ $isActive, $iconType }) => {
      if ($iconType === "setting") {
        return $isActive ? "32px" : "22px";
      }
      if ($iconType === "contact") {
        return $isActive ? "32px" : "22px";
      }
      if ($iconType === "dashboard") {
        return $isActive ? "32px" : "22px";
      }
      return $isActive ? "28px" : "22px";
    }};
    object-fit: contain;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    position: relative;
    z-index: 1;
    filter: ${({ $isActive }) =>
      $isActive ? "drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1))" : "none"};
  }
`;
